// List created on 03/12/2025
// List updated on 04/05/2026 MAY THE FORCE BE WITH YOU

const instoreOrderPresetComments = [
  "0126JAN",
  "0226FEB",
  "0226LUNAR",
  "0326EASTER",
  "0326MAR",
  "0326FATHER",
  "0326RAMADAN",
  "0426APR",
  "0426EARTH",
  "0526MAY",
  "0626JUN",
  "0726JUL",
  "0726REFIT",
  "0826AUG",
  "0926SEP",
];

export default instoreOrderPresetComments;
